module.exports = __webpack_public_path__ + "static/media/authorizedSC.f2e14b02.svg";